<template>
  <div v-if="!isLoading">
    <div class="columns has-margin-bottom-md">
      <div class="column is-9">
        <h1 class="title is-3" v-t="'title'" />
      </div>
      <div class="column is-3 has-text-right">
        <router-link
          v-if="$auth.check(['admin', 'support'])"
          :to="{ name: 'new-question' }"
          class="button is-danger">
          <b-icon icon="plus" size="is-small" />
          <span v-t="'new_question'" />
        </router-link>
      </div>
    </div>
    <div v-if="questions.length > 0" class="columns is-multiline">
      <div class="column is-half" v-for="(question, index) in questions" :key="index">
        <question-box :data="question" :has-icon="false" />
      </div>
    </div>
    <div v-else class="has-text-grey has-text-centered">
      <b-icon icon="exclamation-triangle" size="is-large" />
      <div class="content is-medium">
        <p>
          <span v-t="'nothing_found'" /><br>
          <span v-t="'select_article'" />
        </p>
      </div>
    </div>
  </div>
  <loading-content v-else />
</template>

<script>
import API from '@/api'
import QuestionBox from '@/components/QuestionBox'
import LoadingContent from '@/components/LoadingContent'

export default {
  name: 'QuestionIndex',
  props: { product: { type: Object, required: true } },
  components: {
    QuestionBox,
    LoadingContent
  },
  data () {
    return {
      isLoading: true,
      questions: []
    }
  },
  mounted () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.isLoading = true
      API.questions.index({
        filter_attrs: { product_id: this.product.id },
        order_by: 'views;desc',
        take: -1
      }, questions => {
        this.questions = questions
        this.isLoading = false
      })
    }
  },
  watch: {
    product () {
      this.fetchAll()
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "title": "Frequently Asked Questions / FAQ",
    "new_question": "New Question",
    "nothing_found": "No frequent questions so far.",
    "select_article": "Select an article in the left panel to continue."
  },
  "pt-BR": {
    "title": "Dúvidas Frequentes / FAQ",
    "new_question": "Nova Pergunta",
    "nothing_found": "Nenhuma dúvida frequente até o momento.",
    "select_article": "Selecione um artigo no box lateral para continuar."
  }
}
</i18n>
